import { FirebaseServices } from "./config";
import { callFunction } from "./helpers";
import { entityCache } from "../sync/entity-cache";
import {
  UploadMediaRequest,
  UploadMediaResponse,
  GetMyMediaRequest,
  GetMyMediaResponse,
  GetAllMediaRequest,
  GetAllMediaResponse,
  GetMediaRequest,
  GetMediaResponse,
  EditMediaRequest,
  DeleteMediaRequest,
  StandardResponse,
  ConnectGoogleDriveStorageRequest,
  ConnectGoogleDriveStorageResponse,
  DisconnectGoogleDriveStorageRequest,
  DisconnectGoogleDriveStorageResponse,
} from "common247";

export async function createMedia(fb: FirebaseServices, request: UploadMediaRequest): Promise<UploadMediaResponse> {
  const result = await callFunction(fb, "createMediaFunc", request);
  return result as UploadMediaResponse;
}

export const uploadMedia = createMedia;

export async function getMedia(fb: FirebaseServices, request: GetMediaRequest): Promise<GetMediaResponse> {
  const result = await callFunction(fb, "getMediaFunc", request);
  return result as GetMediaResponse;
}

export async function getMyMedia(fb: FirebaseServices, request: GetMyMediaRequest): Promise<GetMyMediaResponse> {
  const result = (await callFunction(fb, "getMyMediaFunc", request)) as GetMyMediaResponse;
  if (result && Array.isArray(result.media)) {
    entityCache.setCachedList("media", result.media, "myMedia");
  }
  return result;
}

export async function getAllMedia(fb: FirebaseServices, request: GetAllMediaRequest): Promise<GetAllMediaResponse> {
  const result = await callFunction(fb, "getAllMediaFunc", request);
  return result as GetAllMediaResponse;
}

export async function editMedia(fb: FirebaseServices, request: EditMediaRequest): Promise<StandardResponse> {
  const result = await callFunction(fb, "editMediaFunc", request);
  return result as StandardResponse;
}

export async function deleteMedia(fb: FirebaseServices, request: DeleteMediaRequest): Promise<StandardResponse> {
  const result = await callFunction(fb, "deleteMediaFunc", request);
  return result as StandardResponse;
}

export async function getUserStorageQuota(
  fb: FirebaseServices,
  request: { uid?: string } = {}
): Promise<{ status: boolean; quota?: any; error?: string }> {
  const result = await callFunction(fb, "getUserStorageQuotaFunc", request);
  return result as any;
}

export async function connectGoogleDriveStorage(
  fb: FirebaseServices,
  request: ConnectGoogleDriveStorageRequest
): Promise<ConnectGoogleDriveStorageResponse> {
  const result = await callFunction(fb, "connectGoogleDriveStorageFunc", request);
  return result as ConnectGoogleDriveStorageResponse;
}

export async function disconnectGoogleDriveStorage(
  fb: FirebaseServices,
  request: DisconnectGoogleDriveStorageRequest = {}
): Promise<DisconnectGoogleDriveStorageResponse> {
  const result = await callFunction(fb, "disconnectGoogleDriveStorageFunc", request);
  return result as DisconnectGoogleDriveStorageResponse;
}

